/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  DeleteApiV1CourseId202,
  DeleteApiV1CourseId401,
  DeleteApiV1CourseId404,
  DeleteApiV1CourseId500,
  DeleteApiV1CourseIdMutationResponse,
  DeleteApiV1CourseIdPathParams,
} from "../../types/courseRegistrationController/DeleteApiV1CourseId.ts";

export const deleteApiV1CourseIdPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<DeleteApiV1CourseIdPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const deleteApiV1CourseId202Schema =
  z.any() as unknown as ToZod<DeleteApiV1CourseId202>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const deleteApiV1CourseId401Schema =
  z.any() as unknown as ToZod<DeleteApiV1CourseId401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const deleteApiV1CourseId404Schema =
  z.any() as unknown as ToZod<DeleteApiV1CourseId404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const deleteApiV1CourseId500Schema =
  z.any() as unknown as ToZod<DeleteApiV1CourseId500>;

export const deleteApiV1CourseIdMutationResponseSchema = z.lazy(
  () => deleteApiV1CourseId202Schema,
) as unknown as ToZod<DeleteApiV1CourseIdMutationResponse>;
